import { queryOptions } from '@tanstack/react-query'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  AccountingStatistics,
  AccountingStatisticsResponse,
  getAccountingStatistics,
} from 'src/feature/AccountingSummaryBar/accountingStatistics.network'
import { transactionsQueryKeys } from 'src/queries/queries.constants'

export const accountingStatisticsQueries = {
  statistics: (filters?: Partial<TransactionsFiltersBody>) =>
    queryOptions({
      queryKey: transactionsQueryKeys.accountingStatistics(filters),
      queryFn: () => getAccountingStatistics(filters),
      select: (data: AccountingStatisticsResponse): AccountingStatistics =>
        data.statisticsData,
    }),
}
